function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import colors from "../foundations/colors";
const background = {
    // Background accent
    'background.accent.onContent.default': {
        default: `${colors.neutral[180]}3d`,
        _dark: `${colors.neutral[180]}3d`
    },
    'background.accent.onContent.disabled': {
        default: `${colors.neutral[80]}14`,
        _dark: `${colors.neutral[80]}14`
    },
    'background.accent.onContent.hovered': {
        default: `${colors.neutral[170]}66`,
        _dark: `${colors.neutral[170]}66`
    },
    'background.accent.onContent.pressed': {
        default: `${colors.neutral[160]}8f`,
        _dark: `${colors.neutral[160]}8f`
    },
    'background.accent.onDark.default': {
        default: colors.neutral[10],
        _dark: colors.neutral[10]
    },
    'background.accent.onDark.disabled': {
        default: colors.neutral[30],
        _dark: colors.neutral[30]
    },
    'background.accent.onDark.hovered': {
        default: colors.neutral[20],
        _dark: colors.neutral[20]
    },
    'background.accent.onDark.pressed': {
        default: colors.neutral[30],
        _dark: colors.neutral[30]
    },
    'background.accent.onDark.selected': {
        default: colors.neutral[20],
        _dark: colors.neutral[20]
    },
    'background.accent.onLight.default': {
        default: colors.neutral[190],
        _dark: colors.neutral[190]
    },
    'background.accent.onLight.disabled': {
        default: colors.neutral[170],
        _dark: colors.neutral[170]
    },
    'background.accent.onLight.hovered': {
        default: colors.neutral[180],
        _dark: colors.neutral[180]
    },
    'background.accent.onLight.pressed': {
        default: colors.neutral[170],
        _dark: colors.neutral[170]
    },
    'background.accent.onLight.selected': {
        default: colors.neutral[180],
        _dark: colors.neutral[180]
    },
    'background.accent.primary.default': {
        default: colors.purple[100],
        _dark: colors.purple[100]
    },
    'background.accent.primary.disabled': {
        default: colors.neutral[40],
        _dark: colors.neutral[160]
    },
    'background.accent.primary.hovered': {
        default: colors.purple[110],
        _dark: colors.purple[90]
    },
    'background.accent.primary.pressed': {
        default: colors.purple[120],
        _dark: colors.purple[80]
    },
    // Background feedback
    'background.feedback.error.default': {
        default: colors.red[100],
        _dark: colors.red[100]
    },
    'background.feedback.error.disabled': {
        default: colors.neutral[40],
        _dark: colors.neutral[160]
    },
    'background.feedback.error.hovered': {
        default: colors.red[110],
        _dark: colors.red[90]
    },
    'background.feedback.error.pressed': {
        default: colors.red[120],
        _dark: colors.red[80]
    },
    'background.feedback.success.default': {
        default: colors.green[100],
        _dark: colors.green[100]
    },
    'background.feedback.success.disabled': {
        default: colors.neutral[40],
        _dark: colors.neutral[160]
    },
    'background.feedback.success.hovered': {
        default: colors.green[110],
        _dark: colors.green[90]
    },
    'background.feedback.success.pressed': {
        default: colors.green[120],
        _dark: colors.green[80]
    },
    'background.feedback.warning.default': {
        default: colors.carrot[100],
        _dark: colors.carrot[100]
    },
    'background.feedback.warning.disabled': {
        default: colors.neutral[40],
        _dark: colors.neutral[160]
    },
    'background.feedback.warning.hovered': {
        default: colors.carrot[110],
        _dark: colors.carrot[90]
    },
    'background.feedback.warning.pressed': {
        default: colors.carrot[120],
        _dark: colors.carrot[80]
    },
    // Background neutral
    'background.neutral.inverse.default': {
        default: colors.neutral[190],
        _dark: colors.neutral[10]
    },
    'background.neutral.inverse.disabled': {
        default: colors.neutral[170],
        _dark: colors.neutral[30]
    },
    'background.neutral.inverse.hovered': {
        default: colors.neutral[180],
        _dark: colors.neutral[20]
    },
    'background.neutral.inverse.pressed': {
        default: colors.neutral[170],
        _dark: colors.neutral[30]
    },
    'background.neutral.inverse.selected': {
        default: colors.neutral[180],
        _dark: colors.neutral[20]
    },
    'background.neutral.primary.default': {
        default: colors.neutral[10],
        _dark: colors.neutral[190]
    },
    'background.neutral.primary.disabled': {
        default: colors.neutral[30],
        _dark: colors.neutral[170]
    },
    'background.neutral.primary.hovered': {
        default: colors.neutral[20],
        _dark: colors.neutral[180]
    },
    'background.neutral.primary.pressed': {
        default: colors.neutral[30],
        _dark: colors.neutral[170]
    },
    'background.neutral.primary.selected': {
        default: colors.neutral[20],
        _dark: colors.neutral[180]
    },
    'background.neutral.secondary.default': {
        default: colors.neutral[20],
        _dark: colors.neutral[180]
    },
    'background.neutral.secondary.disabled': {
        default: colors.neutral[30],
        _dark: colors.neutral[170]
    },
    'background.neutral.secondary.hovered': {
        default: colors.neutral[30],
        _dark: colors.neutral[170]
    },
    'background.neutral.secondary.pressed': {
        default: colors.neutral[40],
        _dark: colors.neutral[160]
    },
    'background.neutral.secondary.selected': {
        default: colors.neutral[30],
        _dark: colors.neutral[170]
    },
    'background.neutral.tertiary.default': {
        default: colors.neutral[30],
        _dark: colors.neutral[170]
    },
    'background.neutral.tertiary.disabled': {
        default: colors.neutral[40],
        _dark: colors.neutral[160]
    },
    'background.neutral.tertiary.hovered': {
        default: colors.neutral[40],
        _dark: colors.neutral[160]
    },
    'background.neutral.tertiary.pressed': {
        default: colors.neutral[50],
        _dark: colors.neutral[150]
    },
    'background.neutral.tertiary.selected': {
        default: colors.neutral[40],
        _dark: colors.neutral[160]
    },
    // Background brand
    'background.brand.white': {
        default: colors.neutral[20],
        _dark: colors.neutral[20]
    },
    'background.brand.black': {
        default: colors.neutral[180],
        _dark: colors.neutral[180]
    },
    'background.brand.acid': {
        default: colors.acid[100],
        _dark: colors.acid[100]
    },
    'background.brand.orange': {
        default: colors.orange[100],
        _dark: colors.orange[100]
    },
    'background.brand.flame': {
        default: colors.brand.flame,
        _dark: colors.brand.flame
    },
    'background.brand.lava': {
        default: colors.brand.lava,
        _dark: colors.brand.lava
    },
    'background.brand.pink': {
        default: colors.brand.pink,
        _dark: colors.brand.pink
    },
    'background.brand.magenta': {
        default: colors.brand.magenta,
        _dark: colors.brand.magenta
    },
    'background.brand.purple': {
        default: colors.purple[100],
        _dark: colors.purple[100]
    },
    'background.brand.indigo': {
        default: colors.brand.indigo,
        _dark: colors.brand.indigo
    },
    'background.brand.blue': {
        default: colors.brand.blue,
        _dark: colors.brand.blue
    },
    'background.brand.jellyfish': {
        default: colors.brand.jellyfish,
        _dark: colors.brand.jellyfish
    },
    'background.brand.algae': {
        default: colors.brand.algae,
        _dark: colors.brand.algae
    },
    'background.brand.teal': {
        default: colors.teal[100],
        _dark: colors.teal[100]
    },
    'background.brand.lavender': {
        default: colors.purple[70],
        _dark: colors.purple[70]
    },
    // Generic covers
    'background.genericCover.default': {
        default: colors.orange[60],
        _dark: colors.orange[90]
    }
};
const border = {
    // Accent
    'border.accent.onContent.default': {
        default: colors.neutral[10],
        _dark: colors.neutral[10]
    },
    'border.accent.onContent.disabled': {
        default: colors.neutral[100],
        _dark: colors.neutral[100]
    },
    'border.accent.onContent.focused': {
        default: colors.purple[100],
        _dark: colors.purple[100]
    },
    'border.accent.onContent.hovered': {
        default: colors.neutral[20],
        _dark: colors.neutral[20]
    },
    'border.accent.onContent.pressed': {
        default: colors.neutral[30],
        _dark: colors.neutral[30]
    },
    'border.accent.primary.default': {
        default: colors.purple[100],
        _dark: colors.purple[100]
    },
    'border.accent.primary.disabled': {
        default: colors.neutral[50],
        _dark: colors.neutral[150]
    },
    'border.accent.primary.focused': {
        default: colors.neutral[190],
        _dark: colors.neutral[10]
    },
    'border.accent.primary.hovered': {
        default: colors.purple[110],
        _dark: colors.purple[90]
    },
    'border.accent.primary.pressed': {
        default: colors.purple[130],
        _dark: colors.purple[70]
    },
    // Cover
    'border.cover.neutral.default': {
        default: colors.cover.border.light,
        _dark: colors.cover.border.dark
    },
    // Feedback
    'border.feedback.error.default': {
        default: colors.red[100],
        _dark: colors.red[100]
    },
    'border.feedback.error.disabled': {
        default: colors.neutral[50],
        _dark: colors.neutral[150]
    },
    'border.feedback.error.focused': {
        default: colors.purple[100],
        _dark: colors.purple[100]
    },
    'border.feedback.error.hovered': {
        default: colors.red[100],
        _dark: colors.red[100]
    },
    'border.feedback.error.pressed': {
        default: colors.red[100],
        _dark: colors.red[100]
    },
    'border.feedback.success.default': {
        default: colors.green[100],
        _dark: colors.green[100]
    },
    'border.feedback.success.disabled': {
        default: colors.neutral[50],
        _dark: colors.neutral[150]
    },
    'border.feedback.success.focused': {
        default: colors.purple[100],
        _dark: colors.purple[100]
    },
    'border.feedback.success.hovered': {
        default: colors.green[100],
        _dark: colors.green[100]
    },
    'border.feedback.success.pressed': {
        default: colors.green[100],
        _dark: colors.green[100]
    },
    'border.feedback.warning.default': {
        default: colors.carrot[100],
        _dark: colors.carrot[100]
    },
    'border.feedback.warning.disabled': {
        default: colors.neutral[50],
        _dark: colors.neutral[150]
    },
    'border.feedback.warning.focused': {
        default: colors.purple[100],
        _dark: colors.purple[100]
    },
    'border.feedback.warning.hovered': {
        default: colors.carrot[100],
        _dark: colors.carrot[100]
    },
    'border.feedback.warning.pressed': {
        default: colors.carrot[100],
        _dark: colors.carrot[100]
    },
    // Neutra;
    'border.neutral.primary.default': {
        default: colors.neutral[60],
        _dark: colors.neutral[140]
    },
    'border.neutral.primary.disabled': {
        default: colors.neutral[50],
        _dark: colors.neutral[150]
    },
    'border.neutral.primary.focused': {
        default: colors.purple[100],
        _dark: colors.purple[100]
    },
    'border.neutral.primary.hovered': {
        default: colors.neutral[70],
        _dark: colors.neutral[130]
    },
    'border.neutral.primary.pressed': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    }
};
const divider = {
    // Neutral
    'divider.neutral.primary.default': {
        default: colors.neutral[40],
        _dark: colors.neutral[160]
    },
    'divider.neutral.primary.disabled': {
        default: colors.neutral[30],
        _dark: colors.neutral[170]
    },
    'divider.neutral.primary.hovered': {
        default: colors.neutral[50],
        _dark: colors.neutral[150]
    },
    'divider.neutral.primary.pressed': {
        default: colors.neutral[60],
        _dark: colors.neutral[140]
    }
};
const icon = {
    // Accent
    'icon.accent.onDark.default': {
        default: colors.neutral[10],
        _dark: colors.neutral[10]
    },
    'icon.accent.onDark.disabled': {
        default: colors.neutral[120],
        _dark: colors.neutral[120]
    },
    'icon.accent.onDark.hovered': {
        default: colors.neutral[20],
        _dark: colors.neutral[20]
    },
    'icon.accent.onDark.pressed': {
        default: colors.neutral[30],
        _dark: colors.neutral[30]
    },
    'icon.accent.onDark.selected': {
        default: colors.purple[90],
        _dark: colors.purple[90]
    },
    'icon.accent.onLight.default': {
        default: colors.neutral[190],
        _dark: colors.neutral[190]
    },
    'icon.accent.onLight.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[80]
    },
    'icon.accent.onLight.hovered': {
        default: colors.neutral[180],
        _dark: colors.neutral[180]
    },
    'icon.accent.onLight.pressed': {
        default: colors.neutral[170],
        _dark: colors.neutral[170]
    },
    'icon.accent.onLight.selected': {
        default: colors.purple[110],
        _dark: colors.purple[110]
    },
    'icon.accent.primary.default': {
        default: colors.purple[110],
        _dark: colors.purple[90]
    },
    'icon.accent.primary.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'icon.accent.primary.hovered': {
        default: colors.purple[120],
        _dark: colors.purple[80]
    },
    'icon.accent.primary.pressed': {
        default: colors.purple[130],
        _dark: colors.purple[70]
    },
    // Feedback
    'icon.feedback.error.default': {
        default: colors.red[100],
        _dark: colors.red[100]
    },
    'icon.feedback.error.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'icon.feedback.error.hovered': {
        default: colors.red[110],
        _dark: colors.red[90]
    },
    'icon.feedback.error.pressed': {
        default: colors.red[120],
        _dark: colors.red[80]
    },
    'icon.feedback.success.default': {
        default: colors.green[100],
        _dark: colors.green[100]
    },
    'icon.feedback.success.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'icon.feedback.success.hovered': {
        default: colors.green[110],
        _dark: colors.green[90]
    },
    'icon.feedback.success.pressed': {
        default: colors.green[120],
        _dark: colors.green[80]
    },
    'icon.feedback.warning.default': {
        default: colors.carrot[100],
        _dark: colors.carrot[100]
    },
    'icon.feedback.warning.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'icon.feedback.warning.hovered': {
        default: colors.carrot[110],
        _dark: colors.carrot[90]
    },
    'icon.feedback.warning.pressed': {
        default: colors.carrot[120],
        _dark: colors.carrot[80]
    },
    // Neutral
    'icon.neutral.inverse.default': {
        default: colors.neutral[10],
        _dark: colors.neutral[190]
    },
    'icon.neutral.inverse.disabled': {
        default: colors.neutral[120],
        _dark: colors.neutral[80]
    },
    'icon.neutral.inverse.hovered': {
        default: colors.neutral[20],
        _dark: colors.neutral[180]
    },
    'icon.neutral.inverse.pressed': {
        default: colors.neutral[30],
        _dark: colors.neutral[170]
    },
    'icon.neutral.inverse.selected': {
        default: colors.purple[90],
        _dark: colors.purple[110]
    },
    'icon.neutral.primary.default': {
        default: colors.neutral[190],
        _dark: colors.neutral[10]
    },
    'icon.neutral.primary.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'icon.neutral.primary.hovered': {
        default: colors.neutral[180],
        _dark: colors.neutral[20]
    },
    'icon.neutral.primary.pressed': {
        default: colors.neutral[170],
        _dark: colors.neutral[30]
    },
    'icon.neutral.primary.selected': {
        default: colors.purple[110],
        _dark: colors.purple[90]
    },
    'icon.neutral.secondary.default': {
        default: colors.neutral[120],
        _dark: colors.neutral[80]
    },
    'icon.neutral.secondary.disabled': {
        default: colors.neutral[70],
        _dark: colors.neutral[130]
    },
    'icon.neutral.secondary.hovered': {
        default: colors.neutral[130],
        _dark: colors.neutral[70]
    },
    'icon.neutral.secondary.pressed': {
        default: colors.neutral[140],
        _dark: colors.neutral[60]
    },
    'icon.neutral.secondary.selected': {
        default: colors.neutral[130],
        _dark: colors.neutral[70]
    },
    // Generic covers
    'icon.genericCover.default': {
        default: colors.orange[110],
        _dark: colors.orange[120]
    }
};
const text = {
    // Accent
    'text.accent.onDark.default': {
        default: colors.neutral[10],
        _dark: colors.neutral[10]
    },
    'text.accent.onDark.disabled': {
        default: colors.neutral[120],
        _dark: colors.neutral[120]
    },
    'text.accent.onDark.hovered': {
        default: colors.neutral[20],
        _dark: colors.neutral[20]
    },
    'text.accent.onDark.pressed': {
        default: colors.neutral[30],
        _dark: colors.neutral[30]
    },
    'text.accent.onDark.selected': {
        default: colors.purple[90],
        _dark: colors.purple[90]
    },
    'text.accent.onLight.default': {
        default: colors.neutral[190],
        _dark: colors.neutral[190]
    },
    'text.accent.onLight.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[80]
    },
    'text.accent.onLight.hovered': {
        default: colors.neutral[180],
        _dark: colors.neutral[180]
    },
    'text.accent.onLight.pressed': {
        default: colors.neutral[170],
        _dark: colors.neutral[170]
    },
    'text.accent.onLight.selected': {
        default: colors.purple[110],
        _dark: colors.purple[110]
    },
    'text.accent.primary.default': {
        default: colors.purple[110],
        _dark: colors.purple[90]
    },
    'text.accent.primary.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'text.accent.primary.hovered': {
        default: colors.purple[120],
        _dark: colors.purple[80]
    },
    'text.accent.primary.pressed': {
        default: colors.purple[130],
        _dark: colors.purple[70]
    },
    // Feedback
    'text.feedback.error.default': {
        default: colors.red[100],
        _dark: colors.red[100]
    },
    'text.feedback.error.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'text.feedback.error.hovered': {
        default: colors.red[110],
        _dark: colors.red[90]
    },
    'text.feedback.error.pressed': {
        default: colors.red[120],
        _dark: colors.red[80]
    },
    'text.feedback.success.default': {
        default: colors.green[100],
        _dark: colors.green[100]
    },
    'text.feedback.success.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'text.feedback.success.hovered': {
        default: colors.green[110],
        _dark: colors.green[90]
    },
    'text.feedback.success.pressed': {
        default: colors.green[120],
        _dark: colors.green[80]
    },
    'text.feedback.warning.default': {
        default: colors.carrot[100],
        _dark: colors.carrot[100]
    },
    'text.feedback.warning.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'text.feedback.warning.hovered': {
        default: colors.carrot[110],
        _dark: colors.carrot[90]
    },
    'text.feedback.warning.pressed': {
        default: colors.carrot[120],
        _dark: colors.carrot[80]
    },
    // Neutral
    'text.neutral.inverse.default': {
        default: colors.neutral[10],
        _dark: colors.neutral[190]
    },
    'text.neutral.inverse.disabled': {
        default: colors.neutral[120],
        _dark: colors.neutral[80]
    },
    'text.neutral.inverse.hovered': {
        default: colors.neutral[20],
        _dark: colors.neutral[180]
    },
    'text.neutral.inverse.pressed': {
        default: colors.neutral[30],
        _dark: colors.neutral[170]
    },
    'text.neutral.inverse.selected': {
        default: colors.purple[90],
        _dark: colors.purple[110]
    },
    'text.neutral.primary.default': {
        default: colors.neutral[190],
        _dark: colors.neutral[10]
    },
    'text.neutral.primary.disabled': {
        default: colors.neutral[80],
        _dark: colors.neutral[120]
    },
    'text.neutral.primary.hovered': {
        default: colors.neutral[180],
        _dark: colors.neutral[20]
    },
    'text.neutral.primary.pressed': {
        default: colors.neutral[170],
        _dark: colors.neutral[30]
    },
    'text.neutral.primary.selected': {
        default: colors.purple[110],
        _dark: colors.purple[90]
    },
    'text.neutral.secondary.default': {
        default: colors.neutral[120],
        _dark: colors.neutral[80]
    },
    'text.neutral.secondary.disabled': {
        default: colors.neutral[70],
        _dark: colors.neutral[130]
    },
    'text.neutral.secondary.hovered': {
        default: colors.neutral[130],
        _dark: colors.neutral[70]
    },
    'text.neutral.secondary.pressed': {
        default: colors.neutral[140],
        _dark: colors.neutral[60]
    },
    'text.neutral.secondary.selected': {
        default: colors.purple[130],
        _dark: colors.purple[70]
    }
};
export default _object_spread({}, background, border, divider, icon, text);

//# sourceMappingURL=colors.js.map